/* eslint-disable */

export enum RequestResults {
  idle = 1,
  pending = 2,
  success = 3,
  failed = 4,
}
